<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg780"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs784"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath794"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path792" /></clipPath></defs><g
     id="g786"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g788"><g
         id="g790"
         clip-path="url(#clipPath794)"><g
           id="g796"
           transform="translate(364.5,73)"><path
             d="m 0,0 h -41.5 c -11.046,0 -20,-8.954 -20,-20 v -41.5"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path798" /></g><g
           id="g800"
           transform="translate(366,380.4154)"><path
             d="m 0,0 v 77.647 c 0,11.046 -8.954,20 -20,20 h -77"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path802" /></g><g
           id="g804"
           transform="translate(203.2102,10)"><path
             d="m 0,0 h 99.79 l 63,63 v 57.889"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path806" /></g><g
           id="g808"
           transform="translate(107,478.0625)"><path
             d="m 0,0 h -77 c -11.046,0 -20,-8.954 -20,-20 v -428.062 c 0,-11.046 8.954,-20 20,-20 H 6.205"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path810" /></g><g
           id="g812"
           transform="translate(251.5833,446)"><path
             d="m 0,0 h -127.167 c -6.397,0 -11.583,5.186 -11.583,11.583 V 56 H 11.583 V 11.583 C 11.583,5.186 6.397,0 0,0 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path814" /></g><g
           id="g816"
           transform="translate(77.1111,227.19)"><path
             d="M 0,0 17.94,-17.94 59.662,23.782"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path818" /></g><g
           id="g820"
           transform="translate(187.5929,209.3892)"><path
             d="M 0,0 H 47.118"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path822" /></g><g
           id="g824"
           transform="translate(187.5929,253.25)"><path
             d="M 0,0 H 90.548"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path826" /></g><g
           id="g828"
           transform="translate(77.1111,118.1275)"><path
             d="M 0,0 17.94,-17.94 59.662,23.782"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path830" /></g><g
           id="g832"
           transform="translate(187.5929,100.3267)"><path
             d="M 0,0 H 68.534"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path834" /></g><g
           id="g836"
           transform="translate(187.5929,144.1875)"><path
             d="M 0,0 H 89.95"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path838" /></g><g
           id="g840"
           transform="translate(77.1111,336.19)"><path
             d="M 0,0 17.94,-17.94 59.662,23.782"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path842" /></g><g
           id="g844"
           transform="translate(187.5929,318.3892)"><path
             d="M 0,0 H 44.975"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path846" /></g><g
           id="g848"
           transform="translate(187.5929,362.25)"><path
             d="M 0,0 H 111.366"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path850" /></g><g
           id="g852"
           transform="translate(158.2052,10)"><path
             d="M 0,0 V 0"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path854" /></g><g
           id="g856"
           transform="translate(318,323.6157)"><path
             d="m 0,0 v -64.114 c 0,-44.326 29.847,-82.89 72,-94.465 42.153,11.575 72,50.139 72,94.465 V 0 L 72,22.479 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path858" /></g><g
           id="g860"
           transform="translate(389.9957,388)"><path
             d="m 0,0 112.004,-34.968 v -93.531 c 0,-66.184 -46.998,-123.044 -112,-135.501 v 0 0 c -65.001,12.457 -112,69.317 -112,135.501 v 93.531 L 0.009,0"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path862" /></g><g
           id="g864"
           transform="translate(358,258.56)"><path
             d="M 0,0 23.04,-23.04 64,17.92"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path866" /></g></g></g></g></svg>
</template>
